import React, { Component } from 'react'
import { DateRangePicker, createStaticRanges } from 'react-date-range'
import { Message } from '@paypalcorp/worldready-react'
import moment from 'moment'
import { apiConstants } from '../constants/apiConstants'
import { customeDates } from '../constants/datepickerConstants'

class Datepicker extends Component {
  render() {
    const { user } = this.props
    const staticRanges = [...createStaticRanges(customeDates())]
    return (
      <div
        className={`datePicker__component ${this.props?.className || ''}`}
        data-testid="daterange-picker"
      >
        <DateRangePicker
          months={2}
          ranges={[this.props.selectionRange]}
          onChange={this.props.handleSelect}
          moveRangeOnFirstSelection={false}
          showMonthArrow={true}
          showMonthAndYearPickers={false}
          maxDate={moment().toDate()}
          minDate={
            this.props?.minDate
              ? moment(this.props.minDate).toDate()
              : moment()
                  .subtract(apiConstants.FileRetentionDays, 'days')
                  .toDate()
          }
          staticRanges={staticRanges}
        />
        <div className="datePicker__button-container" id="dateSubmit_parent">
          <div className="datePicker__button-content">
            <button
              className="ppvx_btn ppvx_btn--size_sm flexCenter "
              data-pa-pgrp={`dropzone:${user.accType}`}
              data-pa-page={`dropzone:search:date:${user.accType}`}
              data-pa-click="date"
              id="submit_date"
              onClick={() => this.props.handleDateSubmit(false)}
            >
              <Message id="buttons.submit" />
            </button>
            <button
              className="ppvx_btn ppvx_btn--size_sm flexCenter "
              data-pa-pgrp={`dropzone:${user.accType}`}
              data-pa-page={`dropzone:search:clear_date:${user.accType}`}
              data-pa-click="clear_date"
              id="clear_date"
              onClick={() => this.props.handleClearDate(false)}
            >
              <Message id="buttons.clear" />
            </button>
          </div>
        </div>
      </div>
    )
  }
}
export default Datepicker
